module.exports = __webpack_public_path__ + "static/media/meta.4d6464cf.png";